const TransportHome = () => import(/* webpackChunkName: "group-pabx-config" */ '../_views/TransportHome')

import { permissionsPabx } from '../../../../../utils/permissionsPabx'

export default [
  {
    path: 'transport',
    component: TransportHome,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'Transport',
  },
]
